module.exports = __webpack_public_path__ + "img/20.2304c248.png";